import {
    ADD_SHORTLIST_MANAGER,
    ADD_SHORTLIST_MANAGER_FAILURE,
    ADD_SHORTLIST_MANAGER_SUCCESS,
    DELETE_INTERVIEW,
    DELETE_INTERVIEW_ERROR, DELETE_INTERVIEW_SUCCESS,
    GET_ALL_INTERVIEWS, GET_ALL_INTERVIEWS_SUCCESSFULL,
    GET_CANDIDATE_SCREENING_DATA, GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL, GET_CANDIDATE_SCREEN_DATA_FAILED,
    GET_INTERVIEWS,
    GET_INTERVIEWS_FAILED,
    GET_INTERVIEWS_SUCCESSFULL,
    GET_SHORTLIST_CANDIDATE_DATA,
    GET_SHORTLIST_CANDIDATE_DATA_FAILED,
    GET_SHORTLIST_CANDIDATE_DATA_SUCCESS,
    GET_SHORTLIST_MANAGERS_LIST,
    GET_SHORTLIST_MANAGERS_LIST_FAILED,
    GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
    MOVE_TO_SHORTLIST,
    MOVE_TO_SHORTLIST_FAILED,
    MOVE_TO_SHORTLIST_SUCCESS,
    RECRUITMENT_CANDIDATE_DETAIL, RECRUITMENT_CANDIDATE_DETAIL_FAILED, RECRUITMENT_CANDIDATE_DETAIL_SUCCESS,
    UPDATE_SCREENED_CANDIDATE_DETAILS,
    UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED,
    UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS
} from "./actionTypes"

const initialState = {
    loader: false,
    interviewsDetails: null,
    allInterviewsDetails: null,
    interviewsDetailsError: null,
    screenDetails:null,
    screenDetailsError:null,
    updateCandidateDataSuccess:null,
    updateCandidateDataFailed:null,
    shorlistManagerList:null,
    shorlistManagerListError:null,
    addShortListManagerSuccess:null,
    addShortListManagerFailure:null,
    shortlistCandidateData:null,
   shortlistCandidateDataFailure:null,
   updateShortlistCandidateDataSuccess:null,
updateShortlistCandidateDataFailed:null,
recruitmentCandidateData:null,
recruitmentCandidateError:null,
timeLineData:null,
timeLineError:null,
sendReminderData:null,
sendReminderError:null,
showOfferLetterSuccess:null,
showOfferLetterError:null,
deleteInterviewResult:null,
deleteInterviewFailed:null,
}

const getInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INTERVIEWS:
            state = {
                ...state,
                loader: true,
                interviewsDetails: null,
                interviewsDetailsError: null

            }
            break
        case GET_INTERVIEWS_SUCCESSFULL:
            state = {
                ...state,
                loader: false,
                interviewsDetails: action.payload,
                interviewsDetailsError: null

            }
            break
        case GET_INTERVIEWS_FAILED:
            state = {
                ...state,
                loader: false,
                interviewsDetails: null,
                interviewsDetailsError: action.payload
            }
            break
        case GET_ALL_INTERVIEWS:
            state = {
                ...state,
                loader: true,
                interviewsDetailsError: null

            }
            break
        case GET_ALL_INTERVIEWS_SUCCESSFULL:
            state = {
                ...state,
                loader: false,
                allInterviewsDetails: action.payload,
                interviewsDetailsError: null

            }
            break
            case GET_CANDIDATE_SCREENING_DATA:
                state = {
                        ...state,
                        loader: true,
                        screenDetails:null,
                        screenDetailsError:null,
                }
                break 
             case GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL:
                state = {
                            ...state,
                            loader: false,
                            screenDetails:action.payload,
                            screenDetailsError:null,
                }
                break 
                        
            case GET_CANDIDATE_SCREEN_DATA_FAILED:
                state = {
                     ...state,
                                loader: false,
                                screenDetails:null,
                                screenDetailsError:action.payload,
                }
                 break 
            case UPDATE_SCREENED_CANDIDATE_DETAILS:
                state = {
                                        ...state,
                                        loader: true,
                                        updateCandidateDataSuccess:null,
                                        updateCandidateDataFailed:null
                        }
                break  
            case UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS:
                 state = {
                                           ...state,
                                           loader: false,
                                           updateCandidateDataSuccess:action.payload,
                                           updateCandidateDataFailed:null
                 }
                 break     
            case UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED:
                state = {
                                               ...state,
                                               loader: false,
                                               updateCandidateDataSuccess:null,
                                               updateCandidateDataFailed:action.payload
                }
                break
            case GET_SHORTLIST_MANAGERS_LIST:
                state = {
                                                   ...state,
                                                  // loader: true,
                                                   shorlistManagerList:null,
                                                   shorlistManagerListError:null,
                }
                                    break   
                                    
            case GET_SHORTLIST_MANAGERS_LIST_SUCCESS:
                 state = {
                                                       ...state,
                                                       //loader: false,
                                                       shorlistManagerList:action.payload,
                                                       shorlistManagerListError:null,
                }                        
            break 
            case GET_SHORTLIST_MANAGERS_LIST_FAILED:
                state = {
                    ...state,
                    //loader: false,
                    shorlistManagerList:null,
                    shorlistManagerListError:action.payload,                                      
                                           }
            break 
                                            
            case ADD_SHORTLIST_MANAGER:
                state = {
    
    
                    ...state,
                    loader: true,
                    addShortListManagerSuccess:null,
                    addShortListManagerFailure:null,
                                                              
                }
                break  
                case ADD_SHORTLIST_MANAGER_SUCCESS:
                    state = {
                        ...state,
                        loader: false,
                        addShortListManagerSuccess:action.payload,
                        addShortListManagerFailure:null,
                                                                  
                        }
                 break                                  
                                                
                 case ADD_SHORTLIST_MANAGER_FAILURE:
                     state = {
                         ...state,
                        loader: false,
                        addShortListManagerSuccess:null,
                        addShortListManagerFailure:action.payload,
                     }
                break                                  
                                                   
                                                        
                case MOVE_TO_SHORTLIST:
                     state = {
                         ...state,
                        loader: true,
                        candidateMoveToShortlist:null,
                        candidateMoveToShortlistFailure:null,
                    }
                break   
                                                            
                case MOVE_TO_SHORTLIST_SUCCESS:
                state = {
                    ...state,
                    loader: false,
                    candidateMoveToShortlist:action.payload,
                    candidateMoveToShortlistFailure:null,
                    }
                break    
                case MOVE_TO_SHORTLIST_FAILED:
                 state = {
                    ...state,
                        loader: false,
                        candidateMoveToShortlist:null,
                    candidateMoveToShortlistFailure:action.payload,
                 }
                break 
                case GET_SHORTLIST_CANDIDATE_DATA:
                state = {
                     ...state,
                    loader: true,
                    shortlistCandidateData:null,
                    shortlistCandidateDataFailure:null,
                    updateShortlistCandidateDataSuccess:null,
                updateShortlistCandidateDataFailed:null
                }
                 break  
                case GET_SHORTLIST_CANDIDATE_DATA_SUCCESS:
                state = {
                 ...state,
                 loader: false,
                 shortlistCandidateData:action.payload,
                shortlistCandidateDataFailure:null,
                
                }
                break  
                                                                            
                case GET_SHORTLIST_CANDIDATE_DATA_FAILED:
                state = {
                     ...state,
                    loader: false,
                shortlistCandidateData:null,
                shortlistCandidateDataFailure:action.payload,
        }
        break           
         case UPDATE_SHORTLIST_CANDIDATE_DETAILS:
        state = {
                                ...state,
                                loader: true,
                                updateShortlistCandidateDataSuccess:null,
                                updateShortlistCandidateDataFailed:null
                }
        break  
    case UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS:
         state = {
                                   ...state,
                                   loader: false,
                                   updateShortlistCandidateDataSuccess:action.payload,
                                updateShortlistCandidateDataFailed:null
         }
         break     
    case UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED:
        state = {
                                       ...state,
                                       loader: false,
                                       updateShortlistCandidateDataSuccess:null,
                                updateShortlistCandidateDataFailed:action.payload,
        }
        break     
         case RECRUITMENT_CANDIDATE_DETAIL:
        state = {
                                ...state,
                                loader: true,
                                recruitmentCandidateData:null,
                                recruitmentCandidateError:null
                }
        break  
         case RECRUITMENT_CANDIDATE_DETAIL_SUCCESS:
         state = {
                                   ...state,
                                   loader: false,
                                   recruitmentCandidateData:action.payload,
                                   recruitmentCandidateError:null
         }
         break     
         case RECRUITMENT_CANDIDATE_DETAIL_FAILED:
        state = {
                                       ...state,
                                       loader: false,
                                       recruitmentCandidateData:null,
                                       recruitmentCandidateError:action.payload,
        }
        break        
       
       
        case DELETE_INTERVIEW:
            state={
              ...state,
              scheduleLoading:true,
              addInterviewerLoader:true,
              deleteInterviewResult:null,
              deleteInterviewFailed:null
            }
          break 
        case DELETE_INTERVIEW_SUCCESS:
            state={
              ...state,
              scheduleLoading:false,
              addInterviewLoader:false,
              deleteInterviewResult:action.payload,
              deleteInterviewFailed:null
            }
          break 
          case DELETE_INTERVIEW_ERROR:
            state={
              ...state,
              scheduleLoading:false,
              addInterviewerLoader:false,
              deleteInterviewResult:null,
              deleteInterviewFailed:action.payload,
            }
          break   
        default:
            state = { ...state }
            break
    }
    return state
}
export default getInterviewReducer